import React, { Component } from "react"
import Layout from "../Layout"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { Loading, HttpError } from "../../components"
import RelatoriosForm from "./RelatoriosForm"

export default class Relatorios extends Component {
  constructor() {
    super()
    this.getTipos = this.getTipos.bind(this)
    this.state = {
      contratos: [],
      showForm: false,
      tipos: []
    }
  }
  componentWillMount() {
    this.getTipos()
  }
  getTipos() {
    ApiHelper.getTiposRelatorios((tipos, error) => {
      if (tipos) {
        this.setState({
          showForm: true,
          tipos: Util.mapTiposDeRelatorios(tipos)
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Relatórios de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Relatórios de contrato">
        {this.state.showForm === true ? (
          <RelatoriosForm tipos={this.state.tipos} />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/Relatorios.js